import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Headers, Http, RequestOptions } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class CollectionService {
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers });

  constructor(
    private http: Http
  ) {
  }

  get(collectionId, pageSize) {
    const url = `${AppSettings.API_ENDPOINT}/collection?id=${collectionId}&page=1&pagesize=${pageSize}`;

    return this.http.get(url, this.options);
  }
}
